// extracted by mini-css-extract-plugin
module.exports = {"terminal":"style_terminal__2FQLx","icon":"style_icon__PulSq"};